<div class="p-col-12" *ngIf="!isConnected">
  <div class="p-mb-3">
    <form
      [formGroup]="crediflowForm"
      class="p-d-flex p-ai-center p-flex-wrap"
      style="gap: 2rem"
    >
      <div>
        <label>Org.nr</label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="pi pi-box"></i>
          </span>
          <input type="text" pInputText formControlName="orgNr" />
        </div>
      </div>

      <div>
        <label>GLN</label>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="pi pi-box"></i>
          </span>
          <input type="text" pInputText formControlName="gln" />
        </div>
      </div>

      <button
        pButton
        class="p-button-secondary-hyperion p-as-end"
        label="Sök"
        icon="pi pi-search"
        type="button"
        style="padding: 1.2rem"
        (click)="onSearch()"
      ></button>
    </form>
  </div>
</div>

<div class="p-col-12">
  <div
    *ngIf="
      !isConnected && crediflowSearchResult && !crediflowSearchResult.length
    "
    class="p-text-center p-mt-5"
  >
    <h3>Inga resultat hittades</h3>
  </div>
  <p-table
    *ngIf="crediflowSearchResult?.length"
    [value]="crediflowSearchResult"
    responsiveLayout="scroll"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Org.nr</th>
        <th>GLN</th>
        <th>Namn</th>
        <th>Kontaktperson</th>
        <th>E-post</th>
        <th>Telefon</th>
        <th>Status</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-result>
      <tr>
        <td>{{ result.cin }}</td>
        <td>{{ result.gln }}</td>
        <td>{{ result.name }}</td>
        <td>{{ result.contactName }}</td>
        <td>{{ result.email }}</td>
        <td>{{ result.phone }}</td>
        <td>
          {{
            !isConnected && !result.requiresConfirmation
              ? 'Redo att aktivera'
              : ''
          }}
          {{
            !isConnected && result.requiresConfirmation
              ? 'Kräver bekräftelse'
              : ''
          }}
          {{ isConnected && isAccepted ? 'Ansluten' : '' }}
          {{ isConnected && !isAccepted ? 'Begäran skickad' : '' }}
        </td>
        <td>
          <button
            *ngIf="isAccepted"
            pButton
            class="p-button-secondary-hyperion"
            label="Ta bort"
            [loading]="isLoading"
            [disabled]="isLoading"
            (click)="onRemoveConnection()"
          ></button>
          <button
            *ngIf="isConnected && !isAccepted"
            pButton
            class="p-button-secondary-hyperion"
            label="Avbryt begäran"
            [loading]="isLoading"
            [disabled]="isLoading"
            (click)="onRemoveConnection()"
          ></button>
          <button
            *ngIf="!isConnected"
            pButton
            [disabled]="isLoading"
            [loading]="isLoading"
            class="p-button-primary-hyperion"
            [label]="result.requiresConfirmation ? 'Begär' : 'Aktivera'"
            (click)="onActivateOrRequestConfirmation(result.partyId)"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
